const RelevoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22px"
      height="18px"
      viewBox="0 0 21.41 17.11"
      {...props}
    >
      <g>
        <path
          d="M5.79,7.11c.42.13.59-.12.75-.46A33.68,33.68,0,0,0,7.86,3.14c.07-.23.11-.48.19-.71A2.49,2.49,0,0,1,8.27,2a.5.5,0,0,1,.56-.23.55.55,0,0,1,.42.37A1.74,1.74,0,0,1,9.3,3.35q-1,3.14-1.92,6.28a3.76,3.76,0,0,0,0,2.39,1,1,0,0,0,1.48.59l1.4-.72a2.23,2.23,0,0,1,1.12-.32.91.91,0,0,1,.89.47.17.17,0,0,1,0,.14,1.28,1.28,0,0,1-.27.4c-1.8,1.4-3.59,2.81-5.48,4.09a2.28,2.28,0,0,1-1.26.41,8,8,0,0,1-1.09,0,5.47,5.47,0,0,1-1.46-.35,1.62,1.62,0,0,1-1-1.51c0-1.07-.05-2.13-.09-3.2,0-.71,0-1.41-.09-2.12a3,3,0,0,0-.14-.65C1.2,8.4,1,7.55.71,6.69.52,6,.35,5.38.13,4.73A2.52,2.52,0,0,1,0,3.79a.39.39,0,0,1,.22-.36.32.32,0,0,1,.37.09,2.2,2.2,0,0,1,.71.89c.37.84.73,1.69,1.1,2.53a.71.71,0,0,0,.31.31c.21.09.37,0,.45-.27.14-.41.26-.82.4-1.22C4,4.53,4.34,3.31,4.74,2.09a3.49,3.49,0,0,1,.2-.44.4.4,0,0,1,.5-.19.39.39,0,0,1,.32.42c0,.28,0,.56-.07.84-.12.9-.23,1.8-.36,2.7,0,.42-.12.83-.19,1.24a.33.33,0,0,0,.32.43Z"
          fill="currentColor"
        />
        <path
          d="M15.48,7.13a.36.36,0,0,0-.39-.22Q14,7,13,7.21A1.61,1.61,0,0,1,11.73,7a.41.41,0,0,1,0-.66.91.91,0,0,1,.37-.15l2.24-.26,1.5-.14a1.26,1.26,0,0,1,.68.16,2.19,2.19,0,0,0,.4.21c.28.09.4,0,.45-.27s.09-.66.12-1c.08-1.08.17-2.15.23-3.23A3.47,3.47,0,0,1,17.93.49a1,1,0,0,1,.35-.44.32.32,0,0,1,.42.07A1,1,0,0,1,19,.89c.06,1.38.13,2.77.2,4.16,0,.77.09,1.54.13,2.31,0,.12,0,.24.15.29a.39.39,0,0,0,.44,0,5,5,0,0,1,1.17-.54l.13,0c.16,0,.24.06.18.2a6,6,0,0,1-.3.69c-.21.43-.45.86-.64,1.3A5.15,5.15,0,0,0,20,11.06a2.08,2.08,0,0,1-.78,1.5,6.68,6.68,0,0,1-1.47.94,2.3,2.3,0,0,1-1.87,0,2.77,2.77,0,0,1-1.43-1.41,10.23,10.23,0,0,1-.79-2.4c-.14-.59-.27-1.19-.4-1.78,0-.25,0-.34.26-.38l1.5-.24A2.27,2.27,0,0,0,15.48,7.13Z"
          fill="currentColor"
        />
        <path
          d="M14.49,5.46h-.14c-.42,0-.48,0-.6-.43-.27-1-.51-1.9-.76-2.85,0-.14-.07-.29-.1-.44A.73.73,0,0,1,13.14,1c.34-.27.65,0,.75.33A4.51,4.51,0,0,1,14,1.9a9.71,9.71,0,0,0,1,2.9c.07.13.14.26.2.4s0,.19-.11.21l-.59.07Z"
          fill="currentColor"
        />
        <path
          d="M12.92,5.71c-.27,0-.3,0-.39-.28-.17-.43-.35-.85-.51-1.28s-.25-.65-.35-1a.79.79,0,0,1,.2-.68.2.2,0,0,1,.34.09c.16.35.32.7.47,1.05.22.55.44,1.1.67,1.65a.35.35,0,0,1-.29.44Z"
          fill="currentColor"
        />
        <path
          d="M10.4,7.51c0,.23-.14.41-.45.5s-.79.18-1.19.27c-.08,0-.17-.1-.13-.19.1-.27.21-.55.33-.82a.31.31,0,0,1,.18-.16c.17,0,.35,0,.52-.06L10,7c.25,0,.41.1.45.43Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default RelevoIcon;
